import { VARIANT } from "@super-ui/components/cart-upsell-nudge/Components/PlanRemoveConfirmationBottomsheetWrapper/constants";
import { CouponModalIds } from "@swiggy-private/cart-types";

export const isGratificationPopupActive = (enabledOverlayId: string) =>
    enabledOverlayId === CouponModalIds.GRATIFICATION_POPUP;

export const isGratificationPopupVariantAnimation = (variant?: string) => variant === VARIANT.ANIMATION;
